<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header
                    :title="$t('library_reservation')"
                    :isNewButton="false"
                ></Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile
                    :title="$t('library_reservation')"
                    :isNewButton="false"
                ></HeaderMobile>
            </template>

            <template v-if="roomLoading">
                <Loading :show="roomLoading" />
            </template>
            <template v-else>
                <div class="row mt-4 px-3">
                    <div class="col-12 mb-3">
                        <h4 class="text-primary font-weight-bold">
                            {{ $t("study_rooms") }}
                        </h4>
                        <p class="text-muted">
                            {{ $t("library_reservation_info_text") }}
                        </p>
                    </div>
                    <div
                        class="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-4"
                        v-for="room in rooms"
                        :key="room.id"
                    >
                        <b-card
                            @click="openRoomModal(room)"
                            class="cursor-pointer room-card border-0 shadow-sm h-100"
                        >
                            <div class="d-flex align-items-center mb-3">
                                <div
                                    class="icon-circle bg-light-primary text-primary mr-3"
                                >
                                    <i class="ri-git-repository-line ri-2x"></i>
                                </div>
                                <h5 class="mb-0 font-weight-bold">
                                    {{ room.name }}
                                </h5>
                            </div>
                            <div
                                class="d-flex justify-content-between align-items-center mt-auto pt-2 border-top"
                            >
                                <span class="text-muted"
                                    ><i class="ri-drag-move-2-line"></i>
                                    {{ $t("total_chairs") }}:</span
                                >
                                <span class="font-weight-bold text-dark">{{
                                    room.number_of_chairs
                                }}</span>
                            </div>
                        </b-card>
                    </div>
                </div>
                <div class="px-3">
                    <b-button
                        variant="primary"
                        @click="() => $router.push('/my-library-reservations')"
                    >
                        {{ $t("my_library_reservations") }}
                    </b-button>
                </div>
            </template>

            <CommonModal
                ref="seatModal"
                size="xl"
                :onHideOnlyX="true"
                @bHideModalHeaderClose="closeModal"
            >
                <template v-slot:CommonModalTitle>
                    <div class="d-flex align-items-center w-100">
                        <span>{{
                            selectedRoom
                                ? selectedRoom.name +
                                  " - " +
                                  $t("reservation_transaction")
                                : $t("reservation_transaction")
                        }}</span>
                    </div>
                </template>
                <template v-slot:CommonModalContent>
                    <Chairs
                        v-if="formProcess === 'chairs'"
                        :selected-room="selectedRoom"
                        ref="chairs"
                        @reservation-selected="onReservationSelected"
                        @close-bottom-modal="closeBottomModal"
                    />
                </template>
            </CommonModal>

            <transition name="door-slide">
                <div
                    v-if="selectedReservationForDoor"
                    class="door-open-toolbar"
                >
                    <div class="px-4 py-3 w-100 position-relative">
                        <!-- Kapat Butonu - Sağ Üst -->
                        <button
                            class="btn-close-toolbar position-absolute"
                            style="top: 8px; right: 8px"
                            @click="selectedReservationForDoor = null"
                        >
                            <i class="ri-close-line"></i>
                        </button>

                        <div
                            class="d-flex flex-column mb-3"
                            style="line-height: 1.4"
                        >
                            <span
                                class="font-weight-bold text-dark"
                                style="font-size: 15px"
                            >
                                {{ selectedReservationForDoor.chair_name }}
                            </span>
                            <span class="text-muted" style="font-size: 13px">
                                {{ selectedReservationForDoor.start_time }} -
                                {{ selectedReservationForDoor.end_time }}
                            </span>
                        </div>


                        <div class="d-flex" style="gap: 10px">
                            <b-button
                                v-if="isOpenDoor(selectedReservationForDoor)"
                                class="door-open-btn font-weight-bold flex-fill"
                                @click="openDoorRequest"
                                :disabled="isDoorOpening || isCancelLoading"
                            >
                                <b-spinner
                                    v-if="isDoorOpening"
                                    small
                                    class="mr-1"
                                ></b-spinner>
                                <span v-else
                                    ><i class="ri-door-open-line mr-1"></i
                                    >{{ $t("open_door") }}</span
                                >
                            </b-button>
                            <b-button
                                class="cancel-reservation-btn font-weight-bold flex-fill"
                                @click="cancelReservationRequest"
                                :disabled="isDoorOpening || isCancelLoading"
                                 v-if="!isOpenDoor(selectedReservationForDoor)"
                            >
                                <b-spinner
                                    v-if="isCancelLoading"
                                    small
                                    class="mr-1"
                                ></b-spinner>
                                <span v-else
                                    ><i class="ri-calendar-close-line mr-1"></i
                                    >{{ $t("do_cancel") }}</span
                                >
                            </b-button>
                        </div>
                    </div>
                </div>
            </transition>
        </app-layout>
    </div>
</template>

<script>
import AppLayout from "@/layouts/AppLayout";
import Header from "@/layouts/AppLayout/Header";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";
import Chairs from "./Chairs";
import LibraryRoomService from "@/services/LibraryRoomService";
import qs from "qs";
import LibraryReservationService from "@/services/LibraryReservationService";
import moment from "moment";

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,
        Chairs,
    },
    data() {
        return {
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: this.toUpperCase("faculty"),
                        field: this.getLocaleField("faculty_name"),
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("program"),
                        field: this.getLocaleField("program_name"),
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("academic_year"),
                        field: "academic_year",
                        sortable: false,
                        hidden: false,
                        formatFn: (row, field) => {
                            return (
                                field.academic_year +
                                "-" +
                                this.getLocaleText(field, "semester_name")
                            );
                        },
                    },
                    {
                        label: this.toUpperCase("course_code"),
                        field: "course_code",
                        sortable: false,
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("section_1"),
                        field: "section",
                        sortable: false,
                        hidden: false,
                    },
                    /*  {
                              label: this.toUpperCase("class"),
                              field: "class",
                              hidden: false,
                          },*/
                    {
                        label: this.toUpperCase("classroom"),
                        field: "classroom_name",
                        sortable: false,
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("instructor"),
                        field: "instructor_name",
                        sortable: false,
                        hidden: false,
                        formatFn: (value, row) => {
                            return (
                                row.instructor_name +
                                " " +
                                row.instructor_surname
                            );
                        },
                    },
                    {
                        label: this.toUpperCase("date"),
                        field: "date",
                        sortable: false,
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("start_time"),
                        field: "start_time",
                        sortable: true,
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("end_time"),
                        field: "end_time",
                        sortable: true,
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("status"),
                        field: "status_name",
                        sortable: false,
                    },
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {
                        section_status: null,
                    },
                    sort: "date",
                    page: 1,
                    limit: 20,
                },
            },
            formProcess: null,
            roomLoading: false,
            selectedRoom: null,
            rooms: [],
            selectedReservationForDoor: null,
            isDoorOpening: false,
            isCancelLoading: false,
        };
    },
    created() {
        this.getRooms();

    },
    computed: {
        user() {
            return this.$store.getters["auth/getUser"];
        },
    },
    methods: {
        onSortChange(params) {
            const sortType = params[0].type == "desc" ? "-" : "";
            this.datatable.queryParams.sort = sortType + params[0].field;
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        closeModal() {
            this.formProcess = null;
            this.selectedReservationForDoor = null;
        },
        closeBottomModal(){
           this.selectedReservationForDoor=null
        },
        onReservationSelected(reservation) {
            this.selectedReservationForDoor = reservation;
        },
        async openDoorRequest() {
            if (!this.selectedReservationForDoor || !this.selectedRoom) return;

            const result = await this.$swal({
                title: this.$t("open_door"),
                text: this.$t("open_door_confirm_text"),
                type: "question",
                showCancelButton: true,
                confirmButtonText: this.$t("yes"),
                cancelButtonText: this.$t("cancel"),
                confirmButtonColor: "#28a745",
            });
            if (!result.value) return;

            try {
                this.isDoorOpening = true;
                await LibraryReservationService.openDoor(this.selectedRoom.id);
                this.$toast.success(this.$t("proccess_success"));
                this.selectedReservationForDoor = null;
            } catch (err) {
                this.showErrors(err,null)
            } finally {
                this.isDoorOpening = false;
            }
        },
        async cancelReservationRequest() {
            if (!this.selectedReservationForDoor) return;
            const result = await this.$swal({
                title: this.$t("reservation_cancel"),
                html: `<b>${this.selectedReservationForDoor.start_time} - ${
                    this.selectedReservationForDoor.end_time
                }</b> ${this.$t("session_cancellation_confirm")}`,
                type: "warning",
                showCancelButton: true,
                confirmButtonText: this.$t("yes"),
                cancelButtonText: this.$t("cancel"),
                confirmButtonColor: "#dc3545",
            });
            if (!result.value) return;
            try {
                this.isCancelLoading = true;
                const res = await LibraryReservationService.cancelReservation(
                    this.selectedReservationForDoor.reservation_id,
                    { status: "canceled" }
                );
                this.$toast.success(this.$t("api." + res.data.message));
                this.selectedReservationForDoor = null;
                await this.$refs.chairs.fetchScheduleForDate();
                if (
                    this.$refs.seatModal &&
                    this.$refs.seatModal.fetchScheduleForDate
                ) {
                    await this.$refs.seatModal.fetchScheduleForDate();
                }
            } catch (err) {
                this.showErrors(err, null);
            } finally {
                this.isCancelLoading = false;
            }
        },
        openRoomModal(room) {
            this.selectedRoom = room;
            this.formProcess = "chairs";
            this.$refs.seatModal.$refs.commonModal.show();
        },
        async getRooms() {
            try {
                this.roomLoading = true;
                const config = {
                    params: {
                        filter: {
                            status: "a",
                        },
                    },
                    paramsSerializer: (params) =>
                        qs.stringify(params, { encode: false }),
                };
                const res = await LibraryRoomService.getAll(config);
                this.rooms = res.data.data;
            } catch (err) {
                this.showErrors(err, null);
            } finally {
                this.roomLoading = false;
            }
        },
        isOpenDoor(reservation) {
            if (!reservation) return false
            const startDate=moment(reservation.date+' '+reservation.start_time).format('YYYY-MM-DD HH:mm')
            const endDate=moment(reservation.date+' '+reservation.end_time).format('YYYY-MM-DD HH:mm')
            const now =moment(new Date()).format('YYYY-MM-DD HH:mm')
            return now>=startDate && now<=endDate
        }
    },
};
</script>

<style scoped>
/* Card Styles */
.room-card {
    transition: all 0.3s ease;
    border-radius: 12px;
}
.room-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1) !important;
}
.icon-circle {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.bg-light-primary {
    background-color: rgba(30, 106, 255, 0.1);
}
</style>

<style>
/* Door Toolbar - Modal dışında, global scope */

/* ── MOBİL (varsayılan): Tam genişlik Alt Bar ── */
.door-open-toolbar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #ffffff;
    border-top: 2px solid #e2e2e2;
    box-shadow: 0 -6px 20px rgba(0, 0, 0, 0.12);
    z-index: 99999;
    padding-bottom: env(safe-area-inset-bottom);
}
.door-open-btn {
    background-color: #28a745 !important;
    border-color: #28a745 !important;
    color: #fff !important;
    border-radius: 8px !important;
    font-size: 15px !important;
    padding: 10px 20px !important;
    white-space: nowrap;
}
.door-open-btn:hover {
    background-color: #218838 !important;
    border-color: #1e7e34 !important;
}
.cancel-reservation-btn {
    background-color: #fff !important;
    border: 1.5px solid #dc3545 !important;
    color: #dc3545 !important;
    border-radius: 8px !important;
    font-size: 13px !important;
    padding: 8px 10px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.cancel-reservation-btn:hover {
    background-color: #dc3545 !important;
    color: #fff !important;
}
.btn-close-toolbar {
    background: none;
    border: none;
    font-size: 20px;
    color: #aaa;
    cursor: pointer;
    padding: 4px 8px;
    line-height: 1;
    flex-shrink: 0;
}
.btn-close-toolbar:hover {
    color: #333;
}
/* Animasyon - transform YOK */
.door-slide-enter-active,
.door-slide-leave-active {
    transition: opacity 0.3s ease, bottom 0.3s ease;
}
.door-slide-enter,
.door-slide-leave-to {
    opacity: 0;
    bottom: -100px;
}

/* ── MASAÜSTÜ (≥ 768px): Alt Ortada Yüzen Kart ── */
@media (min-width: 768px) {
    .door-open-toolbar {
        left: 50%;
        right: auto;
        bottom: 32px;
        width: 520px;
        transform: translateX(-50%);
        border-top: none;
        border-radius: 16px;
        border: 1px solid #e9ecef;
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
        padding-bottom: 0;
    }
    .door-slide-enter,
    .door-slide-leave-to {
        opacity: 0;
        bottom: 0px;
    }
}
</style>
